module.exports = __webpack_public_path__ + "static/media/frequency.00469b8c.jpg";